export const getProductTileId = (id) => `product-${id}`;
